// Verified customer reviews sourced from the business owner's verified dashboards
// on Homestars, Bark, Houzz, BBB, and Google (Nov 2025).
// Aggregate: 157 reviews, 4.9★ weighted average across all platforms.

export const TESTIMONIALS = [
    {
        id: "hs-2024-11-interlock",
        quote: "Shaheen and his crew were fantastic. Fair pricing allowed us to do more within our budget than what we had originally planned. Constant communication, professional, and the crew did a fantastic job in such a quick time frame. Highly recommend.",
        fullQuote: "Shaheen and his crew were fantastic. I found them online and Shaheen called immediately and scheduled someone to come the next day to look at the landscaping we wanted done. I received a quote that evening which was a fair and reasonable price. I did not feel like I was being persuaded to spend more money or to do more than what I had planned and budgeted for. In fact, his fair pricing is what allowed us to do more within our budget than what we had originally planned. We asked for a quote for additional work and Shaheen came himself the very next day to remeasure and provide a price. He did interlocking in the front and slabs with gravel along the entire side of my home. Within 2 days the material was dropped off and the work began. The job was completed 2 days later. Shaheen provided constant and immediate communication. He was so kind and professional and his crew did a fantastic job in such a quick time frame. His crew would call me outside occasionally to ensure things were done to my liking. I would highly recommend this company!",
        name: "Verified Homeowner",
        service: "interlocking",
        rating: 5,
        source: "Homestars",
        date: "2024-11-14",
    },
    {
        id: "hs-2024-09-fence",
        quote: "Shaheen did an amazing job on my fence. The team was professional, on time, and completed the work quickly with great attention to detail. The fence looks fantastic, and I'm really happy with the quality. Highly recommend them!",
        name: "Verified Homeowner",
        service: "fencing",
        rating: 5,
        source: "Homestars",
        date: "2024-09-28",
    },
    {
        id: "bark-2026-06-seher",
        quote: "We had a great experience with Reformity. Omar and Shaheen were excellent throughout the process, providing clear communication and making everything easy from start to finish. Adam and Johnny did a fantastic job with the installation. We're very happy with our new fence and would highly recommend Reformity Inc!",
        name: "Maria Seher",
        service: "fencing",
        rating: 5,
        source: "Bark",
        date: "2026-06-07",
        verified: true,
    },
    {
        id: "bark-2026-05-perryman",
        quote: "Shaheen and his team did an amazing job on the fence installation. They were always in close communication and were professional throughout the whole process.",
        name: "Michael Perryman",
        service: "fencing",
        rating: 5,
        source: "Bark",
        date: "2026-05-29",
        verified: true,
    },
    {
        id: "bark-2026-05-davison",
        quote: "Shaheen was a true professional and knowledgeable about how they would handle the task of removing and installing a new deck.",
        name: "Doug Davison",
        service: "decking",
        rating: 5,
        source: "Bark",
        date: "2026-05-03",
        verified: true,
    },
    {
        id: "bark-2025-11-vargas",
        quote: "We got a 6' aluminum fence and gate. Done in 2 days and reasonably priced. Would highly recommend!!",
        name: "Helena Vargas",
        service: "fencing",
        rating: 5,
        source: "Bark",
        date: "2025-11-20",
        verified: true,
    },
    {
        id: "houzz-spitzig-fence",
        quote: "Had Shaheen attend and give me an estimate on replacing a 20-year-old section of privacy fencing. Within 5 days crew attended and got rid of old fencing and replaced with a solid wooden fence built to our wishes. Cannot say enough about the work quality and quality people I dealt with. Top rate service and work crew.",
        name: "Doug S.",
        service: "fencing",
        rating: 5,
        source: "Houzz",
        date: null,
    },
    {
        id: "bbb-2025-04-alice-b",
        quote: "If you're on the fence about redoing your fence, do not hesitate with this company. They are very professional, organized. The crew was very conscientious and tidy. I had three estimates presented and they were the best price for best construction material choices and excellent workmanship.",
        name: "Alice B.",
        service: "fencing",
        rating: 5,
        source: "BBB",
        date: "2025-04-07",
    },
    {
        id: "bbb-2025-06-savitri-d",
        quote: "I hired Reformity Inc. to do my fence. Pricing was excellent. They're fast, friendly, did a fantastic job in a timely manner & left my yard clean with no garbage. Great company.",
        name: "Savitri D.",
        service: "fencing",
        rating: 5,
        source: "BBB",
        date: "2025-06-23",
    },
    {
        id: "bbb-2025-05-reg-g",
        quote: "Our back garden suffered over the spring with rampant storms — our fence (already 20 years old) collapsed. 140 feet long, >6 feet tall. After 6 estimates, we settled on Reformity — how lucky we were! The crew were efficient, thorough, courteous, and professional. 10 out of 10.",
        fullQuote: "Our back garden suffered over the spring with rampant storms. And our fence (already 20 years old) collapsed….140 feet long and >6 feet tall. After searching online, and receiving onsite estimates from 6 independent contractors, we settled on Reformity Inc. to do the replacement-how lucky we were! The crew he assigned were efficient, thorough, courteous and as professional as he had promised they would be. Despite atrocious weather over the last week they kept on time with the work, and the finished product has been a delight to behold. We really cannot sing their praises enough, and have absolutely no hesitation in recommending this company to anyone who is looking for any outdoor house work/maintenance. We certainly would hire them again for any such jobs we need in the future…10 out of 10 credit in all aspects.",
        name: "Reg G.",
        service: "fencing",
        rating: 5,
        source: "BBB",
        date: "2025-05-28",
    },
    {
        id: "google-johnston-deck",
        quote: "They built a 10 by 12 wooden deck for us — very satisfied with the job and found they were very helpful and made suggestions to make it even better. Our friends have also commented on the good job done and how nice it looks.",
        name: "Ken Johnston",
        service: "decking",
        rating: 5,
        source: "Google",
        date: null,
    },
    {
        id: "google-cupid-fence",
        quote: "We had Reformity Inc build a yard enclosure and fence gate for us and couldn't be happier with the result. The team was professional from the first quote through to the final walkthrough, and the craftsmanship really shows. They stuck to the timeline and price they quoted. Highly recommend.",
        name: "Joshua Cupid",
        service: "fencing",
        rating: 5,
        source: "Google",
        date: null,
    },
    {
        id: "google-mattei-patio",
        quote: "Five-star review for Shaheen and his crew for the phenomenal job they did on my patio installation. They created a beautiful stone patio along with a gorgeous garden bed, and the workmanship exceeded my expectations. The crew was professional, hardworking, detail-oriented, and respectful.",
        name: "Angie Mattei",
        service: "landscaping",
        rating: 5,
        source: "Google",
        date: null,
    },
];

// Curated 6 for the homepage carousel — one from each source plus a bonus Bark
// (Bark has the largest volume so we feature two from there).
export const FEATURED_TESTIMONIAL_IDS = [
    "hs-2024-11-interlock",
    "bark-2026-06-seher",
    "houzz-spitzig-fence",
    "bbb-2025-05-reg-g",
    "google-cupid-fence",
    "bark-2026-05-davison",
];

export const FEATURED_TESTIMONIALS = FEATURED_TESTIMONIAL_IDS
    .map((id) => TESTIMONIALS.find((t) => t.id === id))
    .filter(Boolean);
